var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _g, _rect21, _path, _rect22, _rect23, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg21UpdatedNewTableArrivedDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 68,
    viewBox: "0 0 131 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.74219,
    y: 35.7417,
    width: 114.839,
    height: 24.5161,
    rx: 2.58065,
    fill: "#009823"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.8379,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7402,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.6445,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4512,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 79.3555,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 92.2578,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 105.16,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5469,
    y: 28,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14.8379,
    y: 62.8384,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7402,
    y: 62.8384,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 40.6445,
    y: 62.8384,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4512,
    y: 62.8384,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 79.3555,
    y: 62.8384,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 92.2578,
    y: 62.8384,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 105.16,
    y: 62.8384,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5469,
    y: 62.8384,
    width: 10.3226,
    height: 5.16129,
    rx: 2.58065,
    fill: "#009823"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    y: 42.8386,
    width: 5.16129,
    height: 10.3226,
    rx: 2.58065,
    fill: "#B6B6B6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 125.16,
    y: 42.8386,
    width: 5.16129,
    height: 10.3226,
    rx: 2.58065,
    fill: "#009823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_190_3876",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 40,
    width: 16,
    height: 16
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 48.3867,
    y: 40.2581,
    width: 15.4839,
    height: 15.4839,
    fill: "url(#pattern0_190_3876)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_190_3876)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.3867,
    y: 40.2581,
    width: 15.4839,
    height: 15.4839,
    fill: "white"
  }))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 63.8711,
    y: 38.3225,
    width: 18.0645,
    height: 19.3548,
    rx: 2.58065,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.9875 51.5V50.7568V50.3748C67.9875 49.9963 68.0581 49.6695 68.1991 49.3942C68.3402 49.1155 68.526 48.8746 68.7566 48.6716C68.9905 48.4652 69.2452 48.2845 69.5204 48.1297C69.7991 47.9748 70.0778 47.8286 70.3566 47.691C70.6353 47.5533 70.8899 47.4157 71.1204 47.2781C71.3544 47.137 71.5419 46.9804 71.683 46.8084C71.8241 46.6363 71.8946 46.4333 71.8946 46.1994C71.8946 45.9 71.7897 45.6557 71.5798 45.4665C71.3733 45.2772 71.0895 45.1826 70.7282 45.1826C70.3531 45.1826 70.0348 45.291 69.7733 45.5077C69.5118 45.7245 69.3501 46.0514 69.2882 46.4884H67.8482C67.855 46.0135 67.9652 45.5834 68.1785 45.1981C68.3953 44.8092 68.7187 44.5013 69.1488 44.2742C69.5789 44.0471 70.1191 43.9335 70.7695 43.9335C71.3269 43.9335 71.8069 44.0282 72.2095 44.2174C72.6155 44.4067 72.9286 44.6699 73.1488 45.0071C73.369 45.3443 73.4791 45.7383 73.4791 46.189C73.4791 46.5641 73.4103 46.8875 73.2727 47.1594C73.135 47.4312 72.9527 47.6634 72.7256 47.8561C72.4985 48.0488 72.249 48.2174 71.9772 48.3619C71.7054 48.5065 71.4335 48.6406 71.1617 48.7645C70.8933 48.8884 70.6456 49.0157 70.4185 49.1465C70.1914 49.2738 70.009 49.4183 69.8714 49.58C69.7338 49.7417 69.6649 49.9361 69.6649 50.1632V50.2303H73.4688V51.5H67.9875ZM75.7322 51.5V45.9103H74.4006V45.0587C74.8273 45.0587 75.1713 45.0191 75.4328 44.94C75.6978 44.8574 75.8956 44.7404 76.0264 44.589C76.1571 44.4342 76.2346 44.2501 76.2587 44.0368H77.2599V51.5H75.7322Z",
    fill: "#009823"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 1,
    width: 23.2632,
    height: 22,
    rx: 11,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 1,
    width: 23.2632,
    height: 22,
    rx: 11,
    stroke: "#009823",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.951 14.464V8.794H114.229V14.464H112.951ZM110.749 12.274V10.996H116.419V12.274H110.749ZM117.797 16V15.136V14.692C117.797 14.252 117.879 13.872 118.043 13.552C118.207 13.228 118.423 12.948 118.691 12.712C118.963 12.472 119.259 12.262 119.579 12.082C119.903 11.902 120.227 11.732 120.551 11.572C120.875 11.412 121.171 11.252 121.439 11.092C121.711 10.928 121.929 10.746 122.093 10.546C122.257 10.346 122.339 10.11 122.339 9.838C122.339 9.49 122.217 9.206 121.973 8.986C121.733 8.766 121.403 8.656 120.983 8.656C120.547 8.656 120.177 8.782 119.873 9.034C119.569 9.286 119.381 9.666 119.309 10.174H117.635C117.643 9.622 117.771 9.122 118.019 8.674C118.271 8.222 118.647 7.864 119.147 7.6C119.647 7.336 120.275 7.204 121.031 7.204C121.679 7.204 122.237 7.314 122.705 7.534C123.177 7.754 123.541 8.06 123.797 8.452C124.053 8.844 124.181 9.302 124.181 9.826C124.181 10.262 124.101 10.638 123.941 10.954C123.781 11.27 123.569 11.54 123.305 11.764C123.041 11.988 122.751 12.184 122.435 12.352C122.119 12.52 121.803 12.676 121.487 12.82C121.175 12.964 120.887 13.112 120.623 13.264C120.359 13.412 120.147 13.58 119.987 13.768C119.827 13.956 119.747 14.182 119.747 14.446V14.524H124.169V16H117.797Z",
    fill: "#009823"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_190_3876",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_190_3876",
    transform: "scale(0.00195312)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_190_3876",
    width: 512,
    height: 512,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg21UpdatedNewTableArrivedDuplicate);
export default __webpack_public_path__ + "static/media/21-updated-new-table-arrived-duplicate.670cf1c289525cb0801d0cf998774f76.svg";
export { ForwardRef as ReactComponent };